import { render, staticRenderFns } from "./DeviceAuditLog.vue?vue&type=template&id=d163fd16&"
import script from "./DeviceAuditLog.vue?vue&type=script&lang=js&"
export * from "./DeviceAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports